export default "__VITE_ASSET__Cc48Y$MN__"